// EmailJS Configuration
// Replace these values with your actual EmailJS credentials

export const EMAILJS_CONFIG = {
 SERVICE_ID: process.env.REACT_APP_EMAILJS_SERVICE_ID,
 TEMPLATE_CONTACTO: process.env.REACT_APP_EMAILJS_TEMPLATE_CONTACTO,
 TEMPLATE_SUGERENCIA: process.env.REACT_APP_EMAILJS_TEMPLATE_SUGERENCIA,
 PUBLIC_KEY: process.env.REACT_APP_EMAILJS_PUBLIC_KEY,
 CONTACT_EMAIL: process.env.REACT_APP_CONTACT_EMAIL,
};

// WhatsApp Configuration
export const WHATSAPP_CONFIG = {
  PHONE_NUMBER: process.env.REACT_APP_PHONE_NUMBER,
};

/* 
SETUP INSTRUCTIONS:

1. EmailJS Setup:
   - Go to https://www.emailjs.com/
   - Create an account and verify your email
   - Create a new service (Gmail, Outlook, etc.)
   - Create a new template with these variables:
     * {{from_name}} - Sender's name
     * {{from_email}} - Sender's email
     * {{phone}} - Sender's phone
     * {{message}} - The message content
     * {{to_name}} - Recipient name (optional)
   - Get your Service ID, Template ID, and Public Key
   - Replace the values above

2. WhatsApp Setup:
   - Replace PHONE_NUMBER with your actual WhatsApp number
   - Format: country code + number (e.g., 5491234567890 for Argentina)
   - No spaces, no + symbol

3. Template Example for EmailJS:
   Subject: Nuevo Reclamo - {{from_name}}
   
   Body:
   Hola {{to_name}},
   
   Has recibido un nuevo reclamo:
   
   Nombre: {{from_name}}
   Email: {{from_email}}
   Teléfono: {{phone}}
   
   Mensaje:
   {{message}}
   
   Por favor, contacta al cliente lo antes posible.
*/
